import React from "react";
import { Phone } from "lucide-react";
import { telHref } from "@/lib/whatsapp";
import { useSite } from "@/context/SiteContext";
import { trackEvent } from "@/lib/analytics";

export default function CallButton({ children, className = "", size = "md", variant = "dark", testid, context, showNumber = false }) {
  const { settings } = useSite();
  const phone = settings?.phone || "07448743318";
  const sizes = {
    sm: "h-10 px-4 text-sm",
    md: "h-12 px-6 text-sm",
    lg: "h-14 px-8 text-base",
  };
  const variants = {
    dark: "border border-zinc-900 text-zinc-900 hover:bg-zinc-900 hover:text-white",
    light: "border border-white/40 text-white hover:bg-white hover:text-ink",
  };
  return (
    <a
      data-testid={testid || "call-button"}
      href={telHref(phone)}
      onClick={() => trackEvent("phone_click", { context: context || testid || "generic" })}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-bold transition-transform duration-300 hover:-translate-y-0.5 ${sizes[size]} ${variants[variant]} ${className}`}
    >
      <Phone className="h-5 w-5" />
      {children || (showNumber ? `Call ${phone}` : "Call Us")}
    </a>
  );
}
